<script setup lang="ts">
import { onError, onHide, onLaunch, onShow } from '@dcloudio/uni-app';
import { businessUtils, commonUtils, toast } from './utils';
import errorManager, { ErrorManagerEntryType } from './utils/errorManager';

onLaunch(() => {
  commonUtils.mp.removeLog();
  console.log('[App Launch] => 冷启动');
});

onShow(async (options) => {
  console.log('[App onShow] => 热启动', options);

  // businessUtils.mp.mockUser('');

  /** 埋点加载 */
  businessUtils.matomo.load();

  // 监听登录状态
  await businessUtils.login.watch();

  // 检查登录token
  await businessUtils.login.check();

  // onshow处理
  businessUtils.mp.show(options);

  // 场景值处理
  businessUtils.mp.scene(options);

  // 检查更新
  commonUtils.mp.update();
});

onHide(() => {
  console.log('[ App Hide ]');
});

onError((error) => {
  toast.clear();
  errorManager.report(ErrorManagerEntryType.wechatApplication, {
    message: 'App throw error',
    stack: error,
  });
  console.log(`[App onError] => `, error);
});
</script>

<style lang="scss">
@font-face {
  font-family: din-bold;
  src: url('https://cdn.s3.mall.startcatcher.com/public/D-DINExp-Bold.ttf') format('truetype');
}

@font-face {
  font-family: din;
  src: url('https://cdn.s3.mall.startcatcher.com/public/D-DINExp.ttf') format('truetype');
}

@font-face {
  font-family: siyuan-bold;
  src: url('https://cdn.s3.mall.startcatcher.com/public/SourceHanSansCN-Bold.otf')
    format('truetype');
}

@font-face {
  font-family: siyuan;
  src: url('https://cdn.s3.mall.startcatcher.com/public/SourceHanSansCN-Normal.otf')
    format('truetype');
}

page {
  height: 100%;
  font-size: 28rpx;
}


uni-page-head {
  display: none;
}


:not(not) {
  box-sizing: border-box;
}

.uni-load-more :deep(.uni-load-more__text) {
  font-size: 24rpx;
}

[v-cloak] {
  display: none !important;
}
</style>
